(function () {
  const norm = (v) => String(v || "").trim();

  function money(cents) {
    try {
      return Shopify.formatMoney(cents, Shopify.money_format);
    } catch {
      return "₹" + (cents / 100).toFixed(2);
    }
  }

  function getPresets() {
    const el = document.querySelector(".dsc-mvp__presets");
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || "{}") || {};
    } catch {
      return {};
    }
  }

  function minPriceForGroup(variants, ruleObj) {
    // ruleObj like { option2: [..], option1: [..] }
    if (!ruleObj || typeof ruleObj !== "object") return null;

    const allowedOpt1 = Array.isArray(ruleObj.option1) ? ruleObj.option1.map(norm) : null;
    const allowedOpt2 = Array.isArray(ruleObj.option2) ? ruleObj.option2.map(norm) : null;
    const allowedOpt3 = Array.isArray(ruleObj.option3) ? ruleObj.option3.map(norm) : null;

    let min = Infinity;

    for (const v of variants) {
      if (!v || !v.available) continue;

      const o1 = norm(v.option1);
      const o2 = norm(v.option2);
      const o3 = norm(v.option3);

      if (allowedOpt1 && allowedOpt1.length && !allowedOpt1.includes(o1)) continue;
      if (allowedOpt2 && allowedOpt2.length && !allowedOpt2.includes(o2)) continue;
      if (allowedOpt3 && allowedOpt3.length && !allowedOpt3.includes(o3)) continue;

      if (typeof v.price === "number" && v.price < min) min = v.price;
    }

    return isFinite(min) ? min : null;
  }

  // ✅ NEW: pick lowest "from" price among groups (not sum)
  function computeLowestGroupFrom(variants, preset) {
    const rules = preset?.group_variant_rules;
    const groupLabels = Array.isArray(preset?.picker_labels) ? preset.picker_labels : [];

    if (!rules || typeof rules !== "object" || !groupLabels.length) return null;

    let lowest = Infinity;

    for (const groupLabel of groupLabels) {
      const ruleObj = rules[groupLabel];
      const groupMin = minPriceForGroup(variants, ruleObj);
      if (groupMin == null) continue; // skip groups that can't be priced
      if (groupMin < lowest) lowest = groupMin;
    }

    return isFinite(lowest) ? lowest : null;
  }

  function init() {
    const presets = getPresets();

    document
      .querySelectorAll('.dsc-card-price[data-dsc-mvp="true"], .dsc-product-price[data-dsc-mvp="true"]')
      .forEach((el) => {
        let variants = [];
        try {
          variants = JSON.parse(el.dataset.variants || "[]");
        } catch {
          variants = [];
        }
        if (!Array.isArray(variants) || !variants.length) return;

        const presetKey = el.dataset.dscPreset || "";
        const preset = presets[presetKey];
        if (!preset) return;

        const fromPrice = computeLowestGroupFrom(variants, preset);
        if (fromPrice == null) return;

        el.innerHTML = `
          <div class="price price--from">
            <span class="price-item price-item--regular">
              From ${money(fromPrice)}
            </span>
          </div>
        `;
      });
  }

  document.addEventListener("DOMContentLoaded", init);
})();